import { render, staticRenderFns } from "./CRSwotSummary.vue?vue&type=template&id=fc099972"
import script from "./CRSwotSummary.vue?vue&type=script&lang=js"
export * from "./CRSwotSummary.vue?vue&type=script&lang=js"
import style0 from "./CRSwotSummary.vue?vue&type=style&index=0&id=fc099972&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports